import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import JoinGroup from 'modules/posts/components/Groups/Join'

const JoinGroupPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return <JoinGroup onClose={() => navigate(navigation.dashboard.fullPath())} />
}

export default JoinGroupPage
